import styled from 'styled-components'
import { textMuted } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	gap: 16px;
	padding: 32px;
`

export const Label = styled.p`
	font-size: ${fontSizes.base};
	color: ${textMuted};
	margin: 0;
	font-weight: 500;
`
